export default __webpack_public_path__ + "static/media/registration-background-1.0d3ae2fd.png";